import styled from 'styled-components';
import AppCSS from '../../../../../utils/styled';

export const Components = {
  Container: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 12px;
  `,

  OptionRow: styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 8px;
  `,

  OptionIndex: styled.span`
    ${AppCSS.fonts.label12Bold};
    color: ${AppCSS.colors.greys.darker};
    min-width: 20px;
    padding-top: 14px;
  `,

  ReorderButtonsWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
  `,

  SmallButton: styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 32px;
    height: 40px;
    background-color: ${AppCSS.colors.white};
    ${AppCSS.radiuses.small};
    border: 1px solid ${AppCSS.colors.greys.medium};
    ${AppCSS.fonts.label12Bold};
    color: ${AppCSS.colors.black};
    cursor: pointer;
    &:disabled {
      color: ${AppCSS.colors.greys.medium};
      cursor: not-allowed;
    }
  `,

  RemoveButton: styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 32px;
    height: 40px;
    background-color: ${AppCSS.colors.white};
    ${AppCSS.radiuses.small};
    border: 1px solid ${AppCSS.colors.greys.medium};
    ${AppCSS.fonts.label12Bold};
    color: ${AppCSS.colors.red};
    cursor: pointer;
    &:disabled {
      color: ${AppCSS.colors.greys.medium};
      cursor: not-allowed;
    }
  `,

  AddButton: styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 140px;
    max-height: 40px;
    padding: 10px 16px;
    ${AppCSS.fonts.h5};
    color: ${AppCSS.colors.blues.dark};
    background-color: ${AppCSS.colors.white};
    border: 1px solid ${AppCSS.colors.blues.dark};
    cursor: pointer;
    &:disabled {
      color: ${AppCSS.colors.greys.medium};
      border-color: ${AppCSS.colors.greys.medium};
      cursor: not-allowed;
    }
  `,

  HelperText: styled.span`
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.greys.darker};
  `,

  ErrorMessage: styled.span`
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.red};
  `,

  WarningBanner: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 12px;
    ${AppCSS.radiuses.small};
    border: 1px solid ${AppCSS.colors.orange};
    background-color: ${AppCSS.colors.white};
  `,

  WarningTitle: styled.span`
    ${AppCSS.fonts.label12Bold};
    color: ${AppCSS.colors.orange};
  `,

  WarningText: styled.span`
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.blues.veryDark};
  `,

  UnlockButton: styled.div`
    ${AppCSS.fonts.label12Bold};
    color: ${AppCSS.colors.red};
    cursor: pointer;
    text-decoration: underline;
    padding-top: 4px;
  `,

  ResultsContainer: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 12px;
    ${AppCSS.radiuses.small};
    border: 1px solid ${AppCSS.colors.greys.medium};
  `,

  ResultsTitle: styled.span`
    ${AppCSS.fonts.label12Bold};
    color: ${AppCSS.colors.blues.veryDark};
  `,

  ResultRow: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 4px;
  `,

  ResultLabelRow: styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  `,

  ResultLabel: styled.span`
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.black};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,

  ResultCount: styled.span`
    ${AppCSS.fonts.label12Bold};
    color: ${AppCSS.colors.blues.veryDark};
    white-space: nowrap;
  `,

  ResultBarTrack: styled.div`
    width: 100%;
    height: 6px;
    ${AppCSS.radiuses.small};
    background-color: ${AppCSS.colors.greys.light};
    overflow: hidden;
  `,

  ResultBarFill: styled.div<{ percentage: number }>`
    height: 100%;
    width: ${({ percentage }) => percentage}%;
    background-color: ${AppCSS.colors.blues.dark};
  `,
};
